export default __webpack_public_path__ + "static/media/page-pen.ef882c19.svg";